import commons from './modules/common/commons'
import auth from './modules/auth/auth'
import unity from './modules/period/unity'
import period from './modules/period/period'
import customer from './modules/period/customer'
import stickyNotes from './modules/period/stickyNotes'
import sendMessage from './modules/period/sendMessage'

export default {
  commons,
  auth,
  period,
  unity,
  customer,
  stickyNotes,
  sendMessage,
}
